import { useState, useEffect, useCallback } from 'react';
import OverdraftService from '@portal/services/OverdraftService';

interface UseOverdraftReturn {
  showOverdraftModal: boolean;
  overdraftAmount: number;
  checkOverdraftUsage: (amount: number) => boolean;
  confirmOverdraftUsage: () => void;
  cancelOverdraftUsage: () => void;
}

export const useOverdraft = (): UseOverdraftReturn => {
  const [showOverdraftModal, setShowOverdraftModal] = useState(false);
  const [overdraftAmount, setOverdraftAmount] = useState(0);
  const [pendingCallback, setPendingCallback] = useState<(() => void) | null>(
    null
  );

  const overdraftService = OverdraftService.getInstance();

  useEffect(() => {
    const unsubscribe = overdraftService.subscribe((amount: number) => {
      setOverdraftAmount(amount);
      setShowOverdraftModal(true);
    });

    return unsubscribe;
  }, [overdraftService]);

  const checkOverdraftUsage = useCallback(
    (amount: number): boolean => {
      return overdraftService.checkOverdraftUsage(amount);
    },
    [overdraftService]
  );

  const confirmOverdraftUsage = useCallback(() => {
    setShowOverdraftModal(false);
    if (pendingCallback) {
      pendingCallback();
      setPendingCallback(null);
    }
  }, [pendingCallback]);

  const cancelOverdraftUsage = useCallback(() => {
    setShowOverdraftModal(false);
    setPendingCallback(null);
  }, []);

  return {
    showOverdraftModal,
    overdraftAmount,
    checkOverdraftUsage,
    confirmOverdraftUsage,
    cancelOverdraftUsage,
  };
};
